/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { withStyles, styled } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import { Icon, Button } from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Box from '@material-ui/core/Box';
import { Auth } from 'aws-amplify';

import moment from 'moment';
import ContentHeader from '../components/ContentHeader';
import ConfirmBooking from '../components/ConfirmBooking';
import { getCurrencySymbol } from '../helpers/ticket';
import globalStyles from '../styles';

const styles = theme => ({
    root: {
        background: '#fff',
        border: '0',
        maxWidth: '800px',
        margin: '40px auto 40px',
        paddingBottom: '1px',
        position: 'relative',
        boxShadow: '0px 2px 5px 0px rgba(0,0,0,0.21)',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            margin: '20px 15px'
        }
    },
    rootMulti: {
        maxWidth: '800px',
        margin: '40px auto 40px',
        paddingBottom: '1px',
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            margin: '20px 15px'
        }
    },
    nameContainer: {
        padding: '10px 10px',
        background: '#70d0ff'
    },
    name: {
        color: '#fff'
    },
    description: {
        marginBottom: 0,
        paddingRight: 5,
        paddingLeft: 10
    },
    descriptionList: {
        paddingLeft: 14
    },
    serviceHeading: {
        background: '#70d0ff',
        margin: '10px 20px 0 20px',
        padding: 5,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
        fontSize: '1.2em',
        borderBottom: '1px solid #3e94be',
        textShadow: '1px 1px #3d94bead',
        color: 'white'
    },
    serviceHeadingMain: {
        display: 'flex',
        alignItems: 'center'
    },
    serviceBody: {
        display: 'none'
    },
    serviceBodyOpen: {
        margin: '0 20px 20px 20px',
        padding: 5,
        border: '1px solid #eee'
    },
    serviceTickets: {
        margin: '0 20px 0px',
        padding: '0 0 20px'
    },
    error: {
        margin: '40px 20px',
        color: red[500]
    },
    spinner: {
        margin: '40px auto',
        display: 'block'
    },
    operatorInfo: {
        padding: '0 10px'
    },
    icon: {
        fontSize: '15px'
    },
    button: {
        paddingLeft: '2px',
        paddingRight: '4px',
        background: 'white'
    },
    editStopButton: {
        color: '#008004',
        border: 0,
        fontWeight: 'normal'
    },
    link: {
        ...globalStyles.link,
        fontWeight: 'bold'
    },
    dayLabel: {
        display: 'flex',
        alignItems: 'center',
        textTransform: 'uppercase',
        flexGrow: 1,
        cursor: 'pointer',
        width: '100%',
        height: 50
    },
    dayBar: {
        borderTop: '1px solid #eee',
        borderLeft: '0',
        borderRight: '0',
        borderRadius: 0,
        marginTop: 0,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 50,
        paddingLeft: 5,
        paddingRight: 5,
        cursor: 'pointer',
        color: '#555'
    },
    dayLabelParent: {
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'center',
        flexDirection: 'column',
        flexGrow: 1
    },
    dayBarActive: {
        background: '#f1fff4',
        borderLeft: '2px solid green',
        color: 'green',
        '& label': {
            fontWeight: 'bold'
        }
    },
    dayStop: {
        fontSize: '0.8em',
        color: 'green',
        margin: 0,
        fontWeight: 'normal'
    },
    totalParent: {
        padding: 20,
        fontWeight: 'bold',
        position: 'sticky',
        background: 'white',
        bottom: 0,
        marginTop: 20,
        borderTop: '1px solid #eee',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    checkbox: {
        marginRight: 7
    },
    time: {
        fontWeight: 'bold',
        marginRight: 5
    },
    buyBtn: {
        background: 'green',
        color: 'white',
        border: 'none',
        '&:hover': {
            background: 'green',
            color: 'white',
            border: 'none'
        }
    },
    buyBtnDisabled: {
        background: 'green',
        color: 'white !important',
        border: 'none !important',
        opacity: 0.3
    },
    form: {
        padding: '0 10px 10px'
    },
    input: {
        width: '100%',
        maxWidth: '250px',
        display: 'block',
        margin: '20px auto',
        '& > div': {
            display: 'block'
        },
        '& input': {
            width: 220
        }
    },
    uploadButton: {
        height: '56px',
        margin: '0 auto',
        padding: '0.6em'
    },
    confirmButton: {
        height: '56px',
        margin: '0 0 0 10px',
        padding: '0.6em'
    },
    upload: {
        display: 'none'
    },
    imageUpload: {
        margin: '0 0 40px 0',
        textAlign: 'center'
    },
    datePicker: {
        margin: '0 auto 20px',
        maxWidth: '250px',
        '& > div': {
            width: '100%'
        }
    },
    imagePreview: {
        minHeight: '56px',
        width: '100%',
        maxWidth: '400px',
        margin: '0 auto 10px',
        '& > img': {
            maxWidth: '100%'
        },
        '& > div': {
            background: 'lightgrey',
            minHeight: '56px',
            borderRadius: '4px',
            border: '1px solid'
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: '10px'
        }
    },
    imagePreviewHelp: {
        display: 'block',
        fontWeight: '100',
        padding: '.5em'
    },
    imagePreviewPlaceholder: {
        borderRadius: '0 !important',
        minHeight: '400px !important',
        border: '0 !important',
        width: '252px',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    photoHelp: {
        color: '#03a9f4',
        padding: '1em 0',
        display: 'block'
    },
    formControl: {
        maxWidth: 250,
        width: '100%',
        margin: '0 auto 20px',
        display: 'flex'
    },
    smallPrint: {
        fontSize: 13,
        textAlign: 'center',
        color: '#444',
        marginBottom: 10
    },
    textCenter: {
        textAlign: 'center',
        padding: '20px 10px 0'
    },
    badge: {
        background: '#12b0ff',
        color: 'white',
        borderRadius: '50%',
        padding: '3px',
        width: 20,
        height: 20,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    disabled: {
        color: '#ccc'
    }
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2)
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1)
    }
}));

const BootstrapDialogTitle = props => {
    const { classes, children, onClose, ...other } = props;

    return (
        <DialogTitle {...other} className={classes.title}>
            <Box
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <Box>{children}</Box>
            </Box>
        </DialogTitle>
    );
};

class Service extends Component {
    static formatDescription(description) {
        return description.split('*').filter(el => el !== '');
    }

    constructor(props) {
        super(props);

        this.state = {
            services: null,
            client: null,
            loading: true,
            error: false,
            servicesOpen: {},
            dates: this.nextWeek(),
            selectedJourneys: [],
            hasSelectedJourneys: false,
            passenger: {
                firstName: '',
                lastName: '',
                photo: null
            },
            imagePreviewUrl: null,
            showStopModal: false,
            currentService: null,
            currentServiceStops: null,
            currentDay: null,
            defaultStop: {},
            availability: {},
            previousBookings: []
        };
    }

    async componentDidMount() {
        const {
            match: {
                params: { customerTicketId }
            }
        } = this.props;

        const { dates } = this.state;

        if (!customerTicketId) {
            return;
        }

        try {
            const currentSession = await Auth.currentSession();

            // get customer ticket
            const headers = {
                Authorization: currentSession.getIdToken().getJwtToken()
            };

            const customerTicketResponse = await axios.get(
                `${
                    process.env.REACT_APP_API_ENDPOINT
                }/customer-ticket/user-id/${
                    currentSession.getAccessToken().payload.sub
                }/${customerTicketId}`,
                {
                    headers
                }
            );

            const customerTicket = customerTicketResponse.data;

            let bookingsResponse;
            try {
                const fromDate = dates[0].format('YYYY-MM-DD');
                const toDate = dates[dates.length - 1].format('YYYY-MM-DD');
                bookingsResponse = await axios.get(
                    `${process.env.REACT_APP_BOOKING_API_ENDPOINT}/bookings/by-ctid/${customerTicket.id}/by-date/${fromDate}/${toDate}`,
                    {
                        headers
                    }
                );
            } catch (e) {
                bookingsResponse = [];
                if (e.response.status !== 404) {
                    throw e;
                }
            }

            // get client
            const clientResponse = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}/client/${customerTicket.client_id}`,
                {
                    headers
                }
            );
            const client = clientResponse.data;

            const { services = [] } = client;

            services.sort((a, b) => {
                if (a.time < b.time) {
                    return -1;
                }
                if (a.time > b.time) {
                    return 1;
                }
                return 0;
            });

            const response = await axios.get(
                `${process.env.REACT_APP_PAYMENT_API_ENDPOINT}/service-availability/${client.slug}/advance`,
                {
                    headers
                }
            );

            this.setState({
                client,
                services,
                passenger: {
                    firstName: customerTicket.passenger.first_name,
                    lastName: customerTicket.passenger.last_name
                },
                availability: response.data,
                loading: false,
                previousBookings: bookingsResponse.data || []
            });
        } catch (e) {
            console.error(e);

            const errMessage =
                e.response && e.response.status === 403
                    ? 'You do not have permission to use this ticket. Please log into the original account which purchased the ticket. Hint: Please use the email address where your booking confirmation was sent to.'
                    : 'There was a problem retrieving your pass. Please try again later or contact our support team.';

            this.setState({
                loading: false,
                error: errMessage
            });
        }
    }

    getStop(service, day) {
        const { selectedJourneys } = this.state;
        const journey = selectedJourneys.find(
            item => item.service_id === service.id && item.date === day
        );

        if (!journey) {
            return '';
        }

        return journey.stop;
    }

    handleDateChange = e => {
        const { selectedJourneys, services, defaultStop } = this.state;
        const serviceId = e.target.name.split('#')[0];
        const day = e.target.name.split('#')[1];
        const service = services.find(s => s.id === serviceId);
        const serviceHasStops =
            service && service.stops && service.stops.length > 0;
        let showStopModal = false;

        if (e.target.checked) {
            const journey = {
                service_id: serviceId,
                service_name: service.name,
                date: day,
                time: service.time,
                price: service.price
            };

            if (serviceHasStops && serviceId in defaultStop) {
                journey.stop = defaultStop[serviceId];
                showStopModal = false;
            } else if (serviceHasStops) {
                showStopModal = true;
            }

            selectedJourneys.push(journey);

            this.setState({
                selectedJourneys,
                showStopModal,
                currentServiceStops: service.stops,
                currentService: service,
                currentDay: day
            });
        } else {
            this.setState({
                selectedJourneys: selectedJourneys.filter(
                    item =>
                        !(item.service_id === serviceId && item.date === day)
                )
            });
        }
    };

    nextWeek = () => {
        const now = moment();
        return [
            now,
            now.clone().add(1, 'day'),
            now.clone().add(2, 'day'),
            now.clone().add(3, 'day'),
            now.clone().add(4, 'day'),
            now.clone().add(5, 'day'),
            now.clone().add(6, 'day')
        ];
    };

    isChecked = (serviceId, day) => {
        const { selectedJourneys } = this.state;
        return selectedJourneys.some(
            s => s.service_id === serviceId && s.date === day
        );
    };

    handleEdit = () => {
        this.setState({
            hasSelectedJourneys: false
        });
    };

    checkOpen(serviceId) {
        const { servicesOpen } = this.state;
        return servicesOpen[serviceId];
    }

    calcTotal() {
        const { selectedJourneys } = this.state;
        const total = selectedJourneys.reduce(
            (acc, b) => acc + Number(b.price),
            0
        );
        return total.toFixed(2);
    }

    displayTotalJourneys() {
        const { selectedJourneys } = this.state;

        if (selectedJourneys.length === 1) {
            return '1 journey';
        }
        return `${selectedJourneys.length} journeys`;
    }

    toggleService(serviceId) {
        const { servicesOpen } = this.state;
        servicesOpen[serviceId] = !servicesOpen[serviceId];
        this.setState({
            servicesOpen
        });
    }

    handleClose() {
        this.setState({
            showStopModal: false
        });
    }

    handleStopSelection(service, day, stop) {
        const { selectedJourneys, defaultStop } = this.state;

        const updatedSelectedJourneys = selectedJourneys.map(journey => {
            if (journey.service_id === service.id && journey.date === day) {
                return {
                    ...journey,
                    stop
                };
            }

            return journey;
        });

        defaultStop[service.id] = stop;

        this.setState({
            selectedJourneys: updatedSelectedJourneys,
            showStopModal: false,
            defaultStop
        });
    }

    isDayAvailable(serviceId, dayKey) {
        const { availability } = this.state;
        if (serviceId in availability && dayKey in availability[serviceId]) {
            return availability[serviceId][dayKey] > 0;
        }

        return false;
    }

    isAlreadyBooked(serviceId, dayKey) {
        const { previousBookings } = this.state;

        if (previousBookings && previousBookings.length) {
            const alreadyBooked = previousBookings.find(booking => {
                return (
                    serviceId === booking.s_id &&
                    dayKey === booking.date_svc.split('#')[1]
                );
            });
            return alreadyBooked !== undefined;
        }

        return false;
    }

    renderNumServiceSelections(serviceId) {
        const { selectedJourneys } = this.state;
        const { classes } = this.props;

        const serviceSelections = selectedJourneys.filter(
            journey => serviceId === journey.service_id
        );

        if (!serviceSelections.length) {
            return <></>;
        }

        return (
            <span className={classes.badge}>{serviceSelections.length}</span>
        );
    }

    renderDayItem(date, service) {
        const { selectedJourneys } = this.state;
        const { classes } = this.props;
        const yyyymmddString = date.format('YYYY-MM-DD');

        const dayIsChecked = this.isChecked(service.id, yyyymmddString);
        let dayBarClassName = classes.dayBar;

        if (dayIsChecked) {
            dayBarClassName += ` ${classes.dayBarActive}`;
        }

        const dayAlreadyBooked = this.isAlreadyBooked(
            service.id,
            date.format('YYYY-MM-DD')
        );

        const dayIsAvailable = this.isDayAvailable(
            service.id,
            date.format('YYYYMMDD')
        );

        return (
            <div className={dayBarClassName}>
                <div className={classes.dayLabelParent}>
                    <label
                        key={`${service.id}#${yyyymmddString}`}
                        className={classes.dayLabel}
                        htmlFor={`${service.id}#${yyyymmddString}`}
                    >
                        <input
                            className={classes.checkbox}
                            onChange={this.handleDateChange}
                            name={`${service.id}#${yyyymmddString}`}
                            id={`${service.id}#${yyyymmddString}`}
                            type="checkbox"
                            checked={dayIsChecked || dayAlreadyBooked}
                            disabled={!dayIsAvailable || dayAlreadyBooked}
                        />{' '}
                        <div
                            style={{ flexGrow: 1 }}
                            className={
                                dayIsAvailable && !dayAlreadyBooked
                                    ? ''
                                    : classes.disabled
                            }
                        >
                            {date.format('ddd Do MMM')}
                            <div className={classes.dayStop}>
                                {this.getStop(service, yyyymmddString)}
                            </div>
                        </div>
                    </label>
                </div>
                {this.getStop(service, yyyymmddString) && (
                    <div>
                        <Button
                            variant="outlined"
                            color="primary"
                            className={classes.editStopButton}
                            size="small"
                            onClick={() => {
                                this.setState({
                                    selectedJourneys,
                                    showStopModal: true,
                                    currentServiceStops: service.stops,
                                    currentService: service,
                                    currentDay: yyyymmddString
                                });
                            }}
                        >
                            Edit
                        </Button>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const {
            services,
            client,
            loading,
            error,
            selectedJourneys,
            hasSelectedJourneys,
            imagePreviewUrl,
            passenger
        } = this.state;
        const { classes, match } = this.props;
        const {
            dates,
            showStopModal,
            currentServiceStops,
            currentService,
            currentDay
        } = this.state;

        const {
            params: { customerTicketId }
        } = match;

        const buyAgain = true;

        if (error) {
            return (
                <div>
                    <Typography
                        variant="h6"
                        align="center"
                        className={classes.error}
                    >
                        There was a problem retrieving the bus service data,
                        please try again later.
                    </Typography>
                </div>
            );
        }

        if (loading) {
            return (
                <CircularProgress
                    id="loading-spinner"
                    className={classes.spinner}
                />
            );
        }

        return (
            <>
                <BootstrapDialog
                    aria-labelledby="customized-dialog-title"
                    open={showStopModal}
                    PaperProps={{
                        style: {
                            margin: 16,
                            minWidth: 300
                        }
                    }}
                >
                    <BootstrapDialogTitle
                        id="customized-dialog-title"
                        onClose={() => {
                            this.handleClose();
                        }}
                        classes={classes}
                    >
                        Select bus stop
                    </BootstrapDialogTitle>
                    <DialogContent dividers>
                        <>
                            {currentServiceStops &&
                                currentServiceStops.map(stop => (
                                    <div>
                                        <Button
                                            onClick={() => {
                                                this.handleStopSelection(
                                                    currentService,
                                                    currentDay,
                                                    stop
                                                );
                                            }}
                                        >
                                            {stop}
                                        </Button>
                                    </div>
                                ))}
                        </>
                    </DialogContent>
                </BootstrapDialog>
                {hasSelectedJourneys && (
                    <div className={classes.rootMulti}>
                        <ConfirmBooking
                            booking={selectedJourneys}
                            client={client}
                            imagePreviewUrl={imagePreviewUrl}
                            handleEdit={this.handleEdit}
                            customerTicketId={customerTicketId}
                            passenger={passenger}
                            buyAgain={buyAgain}
                        />
                    </div>
                )}
                {!hasSelectedJourneys && (
                    <div className={classes.root}>
                        <ContentHeader
                            text={client.site_name}
                            id="service-name"
                        />
                        <div style={{ padding: '20px 20px 0' }}>
                            <Typography variant="body2">
                                Services operated by {client.name}.
                            </Typography>
                        </div>
                        {services &&
                            services.length > 0 &&
                            services.map(service => (
                                <div key={service.id}>
                                    <div
                                        id="service-heading"
                                        className={classes.serviceHeading}
                                        onClick={() => {
                                            this.toggleService(service.id);
                                        }}
                                    >
                                        <div
                                            className={
                                                classes.serviceHeadingMain
                                            }
                                        >
                                            <Icon className={classes.icon}>
                                                {this.checkOpen(service.id)
                                                    ? 'keyboard_arrow_down'
                                                    : 'keyboard_arrow_right'}
                                            </Icon>
                                            <div>
                                                <span className={classes.time}>
                                                    {service.time}
                                                </span>{' '}
                                                {service.name}
                                            </div>
                                        </div>
                                        <div>
                                            {this.renderNumServiceSelections(
                                                service.id
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        className={
                                            this.checkOpen(service.id)
                                                ? classes.serviceBodyOpen
                                                : classes.serviceBody
                                        }
                                    >
                                        <div
                                            id="service-description"
                                            className={classes.description}
                                        >
                                            <ul
                                                className={
                                                    classes.descriptionList
                                                }
                                            >
                                                {Service.formatDescription(
                                                    service.description
                                                ).map(item => (
                                                    <li key={item}>
                                                        <Typography variant="body2">
                                                            {item}
                                                        </Typography>
                                                    </li>
                                                ))}
                                            </ul>
                                            <p>
                                                Trip price:{' '}
                                                {getCurrencySymbol(
                                                    client.features.currency
                                                )}
                                                {service.price}
                                            </p>
                                        </div>
                                        <div className={classes.operatorInfo}>
                                            <p>
                                                {service.route_url && (
                                                    <a
                                                        style={{
                                                            textDecoration:
                                                                'none',
                                                            marginRight: '5px'
                                                        }}
                                                        href={service.route_url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            className={
                                                                classes.button
                                                            }
                                                            size="small"
                                                        >
                                                            <Icon
                                                                className={
                                                                    classes.icon
                                                                }
                                                            >
                                                                location_on
                                                            </Icon>{' '}
                                                            Route
                                                        </Button>
                                                    </a>
                                                )}

                                                {service.timetable_url && (
                                                    <a
                                                        style={{
                                                            textDecoration:
                                                                'none',
                                                            marginRight: '5px'
                                                        }}
                                                        href={
                                                            service.timetable_url
                                                        }
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            className={
                                                                classes.button
                                                            }
                                                            size="small"
                                                        >
                                                            <Icon
                                                                className={
                                                                    classes.icon
                                                                }
                                                            >
                                                                access_time
                                                            </Icon>{' '}
                                                            timetable
                                                        </Button>
                                                    </a>
                                                )}

                                                {service.terms_url && (
                                                    <a
                                                        style={{
                                                            textDecoration:
                                                                'none'
                                                        }}
                                                        href={service.terms_url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            className={
                                                                classes.button
                                                            }
                                                            size="small"
                                                        >
                                                            <Icon
                                                                className={
                                                                    classes.icon
                                                                }
                                                            >
                                                                list
                                                            </Icon>
                                                            Terms
                                                        </Button>
                                                    </a>
                                                )}
                                            </p>
                                        </div>
                                        {dates.map(date =>
                                            this.renderDayItem(date, service)
                                        )}
                                    </div>
                                </div>
                            ))}
                        <div className={classes.totalParent}>
                            <div className={classes.total}>
                                Total:{' '}
                                {getCurrencySymbol(client.features.currency)}
                                {this.calcTotal()} (
                                {this.displayTotalJourneys()})
                            </div>
                            <Button
                                variant="outlined"
                                color="primary"
                                className={
                                    selectedJourneys.length === 0
                                        ? classes.buyBtnDisabled
                                        : classes.buyBtn
                                }
                                size="small"
                                disabled={selectedJourneys.length === 0}
                                onClick={() => {
                                    this.setState({
                                        hasSelectedJourneys: true
                                    });
                                    window.scrollTo(0, 0);
                                }}
                            >
                                Buy
                            </Button>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

Service.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            customerTicketId: PropTypes.string
        })
    }).isRequired,
    classes: PropTypes.shape().isRequired
};

export default withStyles(styles)(Service);
